import { put, call, take, fork } from 'redux-saga/effects'
import { patchCollectionPaymentMessagesService } from '../../api/collection'
import {
  patchCollectionPaymentMessagesSuccess,
  patchCollectionPaymentMessagesError,
} from '../../reducers/collection/action'
import { PATCH_COLLECTION_PAYMENT_MESSAGES } from '../../reducers/collection/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

function* flow(payload) {
  try {
    const { collectionId, content, callback } = payload
    const response = yield call(
      patchCollectionPaymentMessagesService,
      collectionId,
      content,
    )
    yield put(patchCollectionPaymentMessagesSuccess(content))
    yield put(operationSuccess())
    if (callback) callback(response?.data ?? response)
  } catch (error) {
    yield put(patchCollectionPaymentMessagesError(error))
    yield put(operationFail(error))
  }
}

export default function* patchCollectionPaymentMessagesWatcher() {
  while (true) {
    const action = yield take(PATCH_COLLECTION_PAYMENT_MESSAGES)
    yield fork(generalSaga, flow, action.payload)
  }
}
